/**
* 订单管理 棋牌订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>棋牌订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.shop_name" placeholder="店铺名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.orderNo" placeholder="输入订单号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" placeholder="下单用户手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.status" placeholder="请选择">
          <el-option v-for="type in orderStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="info" icon="el-icon-refresh" native-type="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="订单ID" width="100" show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="shop_id" label="店铺ID" width="120" show-overflow-tooltip v-if="false">
      </el-table-column>
      <el-table-column sortable prop="room_id" label="包厢ID" width="140" show-overflow-tooltip v-if="false">
      </el-table-column>
      <el-table-column prop="shop_name" label="店铺" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="room_name" label="包厢名称" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mobile" label="下单用户" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="order_no" label="订单编号" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="create_time_txt" label="下单时间" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="amount" label="订单金额" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="pay_amount" label="支付金额" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="balance" label="余额" width="90" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="status_txt" label="状态" width="90" show-overflow-tooltip>
        <!-- 自定义列模板 -->
        <template slot-scope="scope">
          <el-tag
            :type="getStatusTagType(scope.row.status_txt)"
            :disable-transitions="false"
          >
            {{ scope.row.status_txt }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="book_start_txt" label="开始时间" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="book_end_txt" label="结束时间" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mt_code" label="美团码" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="dou_code" label="抖音码" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="tuan_id" label="团购券" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="coupon_id" label="优惠券" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="xu_order_no" label="续单号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="refund_order_no" label="退款单号" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="refund(scope.$index, scope.row)">退款</el-button>
          <!--          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 退款界面 -->
    <el-dialog :title="title" :visible.sync="refundFormVisible" width="50%" @click="closeDialog('refundForm')">
      <el-form label-width="120px" :model="refundForm" ref="refundForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单ID">
              <el-input size="small" v-model="refundForm.id" auto-complete="off" placeholder="订单ID"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="店铺名称">
              <el-input size="small" v-model="refundForm.shop_name" auto-complete="off" placeholder="店铺名称"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="包厢名称">
              <el-input size="small" v-model="refundForm.room_name" auto-complete="off" placeholder="包厢名称"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="订单编号">
              <el-input size="small" v-model="refundForm.order_no" auto-complete="off" placeholder="订单编号"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-input size="small" v-model="refundForm.status_txt" auto-complete="off" placeholder="订单状态"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="订单金额">
              <el-input size="small" v-model="refundForm.amount" auto-complete="off" placeholder="订单金额"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="余额">
              <el-input size="small" v-model="refundForm.balance" auto-complete="off" placeholder="余额金额"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="实付金额">
              <el-input size="small" v-model="refundForm.pay_amount" auto-complete="off" placeholder="实付金额"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <!-- 使用有序列表展示按序排列的文档内容 -->
              <ol class="custom-ordered-list" :style="{ '--line-height': lineHeight + 'px' }">
                <li>余额值默认全退；</li>
                <li>团购券订单会自动退掉团购券的钱；</li>
                <li>实付订单可选择部分退款，需要手动输入</li>
                <li>美团/抖音订单只改变订单状态，退款需要下单用户去对应平台申请</li>
              </ol>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="美团">
              <el-input size="small" v-model="refundForm.mt_code" auto-complete="off" placeholder="美团券码"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="抖音">
              <el-input size="small" v-model="refundForm.dou_code" auto-complete="off" placeholder="抖音券码"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="团购券">
              <el-input size="small" v-model="refundForm.tuan_id" auto-complete="off" placeholder="团购券ID"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="续单号">
              <el-input size="small" v-model="refundForm.xu_order_no" auto-complete="off" placeholder="原订单编号"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="下单时间">
              <el-input size="small" v-model="refundForm.create_time_txt" auto-complete="off" placeholder="下单时间"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-input size="small" v-model="refundForm.book_start_txt" auto-complete="off" placeholder="订单开始时间"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-input size="small" v-model="refundForm.book_end_txt" auto-complete="off" placeholder="订单结束时间"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="退款金额">
              <el-input size="small" v-model.number="refundForm.refund_amount" auto-complete="off"
                        placeholder="仅限输入实付订单退款金额"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button size="small" type="success" icon="el-icon-circle-check" @click="refundBtn">确定退款</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {OrderList, OrderRefund, OrderDelete} from '../../api/payMG'
import Pagination from '../../components/Pagination'
import {qpOrderList, qpRefund} from "../../api/order";

export default {
  data() {
    return {
      lineHeigh: 5,
      loading: false, //是显示加载
      refundFormVisible: false, //控制编辑页面显示与隐藏
      title: '订单退款',
      orderStatus: [
        {key: '请选择', value: 0},
        {key: '已支付', value: 'payed'},
        {key: '进行中', value: 'doing'},
        {key: '已完成', value: 'done'},
        {key: '已退款', value: 'refund'},
        {key: '部分退款', value: 'part_refund'},
      ],
      refundForm: {
        id: '',
        shop_name: null,
        room_name: null,
        order_no: '',
        create_time_txt: '',
        amount: '',
        pay_amount: '',
        status_txt: '',
        book_start_txt: '',
        book_end_txt: '',
        balance: '',
        tuan_id: '',
        mt_code: '',
        dou_code: '',
        xu_order_no: '',
        refund_amount: 0.00,
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        shop_name: '',
        orderNo: '',
        status: '',
        mobile: '',
        org_id: this.$globalConfig.orgId,
        // token: localStorage.getItem('logintoken')
      },

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  methods: {
    getStatusTagType(status) {
      switch (status) {
        case '已支付':
          return 'success'
        case '进行中':
          return 'warning'
        case '已完成':
          return 'danger'
        case '已退款':
          return 'info'
        case '部分退款':
          return 'info'
        default:
          return ''
      }
    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 确保参数中包含 token
      const params = {
        ...parameter,
        token: localStorage.getItem('logintoken')
      }
      qpOrderList(params)
        .then(res => {
          this.loading = false
          if (res.code !== 1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          console.error('API请求错误:', err)
          // 检查是否是token问题
          if (!localStorage.getItem('logintoken')) {
            this.$message.error('登录已过期，请重新登录！')
            this.$router.push('/login')
          } else {
            this.$message.error('菜单加载失败，请稍后再试！')
          }
        })
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },

    //显示退款界面
    refund: function (index, row) {
      this.refundFormVisible = true
      this.refundForm = row
      this.refundForm.refund_amount = row.pay_amount
    },

    //退款
    refundBtn() {
      const params = {
        "id": this.refundForm.id,
        "refund_amount": this.refundForm.refund_amount
      };
      this.loading = true
      qpRefund(params)
        .then(res => {
          this.refundFormVisible = false
          this.loading = false
          if (res.code === 1) {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '退款成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.refundFormVisible = false
          this.loading = false
          this.$message.error('退款失败')
        })
    },

    //弹出框
    closeDialog(formName) {
      this.refundFormVisible = false
      this.$refs[formName].resetFields()
    },

    //重置方法
    reset() {
      this.formInline.shop_name = '';
      this.formInline.orderNo = '';
      this.formInline.status = '';
      this.formInline.mobile = '';
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
.custom-ordered-list {
  padding-left: 20px;
  margin: 0;
}
.custom-ordered-list li {
  line-height: 1.5;
}

.custom-ordered-list li:last-child {
  margin-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/order/Qp.vue